<div class="dashboard-chat-container" [class.expanded]="showChatPanel" (click)="onContainerClick($event)">
  <div class="chat-messages">
    @for (message of chatMessages; track $index) {
      <div class="chat-message ai-message">
        <div class="message-bubble">
          {{ message }}
        </div>
      </div>
    }
    @if (isTyping) {
      <div class="chat-message ai-message">
        <div class="message-bubble typing-bubble">
          <span class="typing-indicator">
            <span></span><span></span><span></span>
          </span>
        </div>
      </div>
    }
  </div>

  <div class="chat-bar-wrapper">
    <form [formGroup]="chatForm" (ngSubmit)="sendMessage()" class="chat-form">
      <div class="chat-input-group">
        <input
          #messageInput
          type="text"
          formControlName="message"
          class="chat-input"
          placeholder="How can we improve?"
          (keydown)="onMessageInputKeydown($event)"
          [disabled]="isRespondingFromLLM" />
        <button
          type="submit"
          class="send-button"
          [disabled]="chatForm.invalid || isRespondingFromLLM"
          (click)="sendMessage()">
          <span class="material-icons">send</span>
        </button>
      </div>
    </form>
  </div>
</div>
